import { api } from "../Configurations/axios";

const MassiveUploadFile = async (files: Blob[], companyId: string, pathId: string, pathMain: string, userEmail: string) => {
    try {
        var UploadFileCommand = new FormData()

        files.map((file: Blob) => {
            UploadFileCommand.append('files', file);
        });

        const result = await api.post(`/FileManager/PostFiles/?CompanyId=${companyId}&PathMain=${pathMain}&userEmail=${encodeURIComponent(userEmail)}&PathId=${pathId != "" ? pathId : " "}`, UploadFileCommand, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        const dataFiles = await result.data;
        return dataFiles;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const GetFilesAPI = async (companyId: string, pathId: string, path: number, page: number = 1, take: number = 7, word: string = "") => {
    try {
        const result = await api.get(`/FileManager/GetFiles/?CompanyId=${companyId}&Path=${path}&PathId=${pathId}&Page=${page}&Take=${take}&Word=${encodeURIComponent(word)}`);
        const response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const SearchFileAPI = async (companyId: string, pathMain: string, page: number = 1, take: number = 7, word: string = "") => {
    try {
        const result = await api.get(`/FileManager/SearchFile/?CompanyId=${companyId}&PathMain=${pathMain}&Page=${page}&Take=${take}&Word=${encodeURIComponent(word)}`);
        const response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const DownloadMassiveAPI = async (filesId: string[], companyId: string) => {
    try {
        const result = await api.get(`/FileManager/DownloadMassive/?filesId=${JSON.stringify(filesId)}&companyId=${companyId}`, {
            responseType: 'blob'
        });
        const response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const DeleteFileAPI = async (fileId: string, companyId: string) => {
    try {
        const result = await api.delete('/FileManager/DeleteFile', { data: { fileId: fileId, companyId: companyId } });
        const response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const DeleteMassiveFileAPI = async (fileId: string[], companyId: string) => {
    try {
        const result = await api.delete('/FileManager/DeleteFileMassive', { data: { fileId: fileId, companyId: companyId } });
        const response = result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

export {
    MassiveUploadFile,
    GetFilesAPI,
    SearchFileAPI,
    DownloadMassiveAPI,
    DeleteFileAPI,
    DeleteMassiveFileAPI
}